import { render } from "./MarkFailedForm.vue?vue&type=template&id=4760c661&scoped=true"
import script from "./MarkFailedForm.vue?vue&type=script&lang=js"
export * from "./MarkFailedForm.vue?vue&type=script&lang=js"

import "./MarkFailedForm.vue?vue&type=style&index=0&id=4760c661&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4760c661"]])

export default __exports__